/**
 * Utility function to extract specific error messages from API responses
 * @param error - The error object from the API response
 * @param fallbackMessage - The generic error message to use if no specific error is found
 * @returns The specific error message or the fallback message
 */
export function extractErrorMessage(error: any, fallbackMessage: string): string {
  const extractFromArray = (errorArray: any[]) => {
    const messages = errorArray
      .map((item: any) => item.error)
      .filter((msg: string) => msg && msg.trim().length > 0);
    return messages.length > 0 ? messages.join('. ') : null;
  };

  // Handle Error objects with JSON message
  if (error?.message && typeof error.message === 'string') {
    try {
      const parsed = JSON.parse(error.message);
      if (Array.isArray(parsed)) {
        const result = extractFromArray(parsed);
        if (result) return result;
      }
    } catch {
      return error.message;
    }
  }

  // Handle direct error arrays
  if (error?.error && Array.isArray(error.error)) {
    const result = extractFromArray(error.error);
    if (result) return result;
  }

  // Handle string errors
  if (error?.error && typeof error.error === 'string') {
    return error.error;
  }

  return fallbackMessage;
}
